import { Button, FloatingLabel, Form, Offcanvas } from "olive-react-myoneui";
import DropdownCommon from "../component/DropdownCommon";
import { useState } from "react";

function AddOffcanvas({ show, onClose, subjects,selectedSubject,setSelectedSubject,setTopics,topics,handleSubmit }) {

      
  

  return (
    <>
      <Offcanvas className="pb-0" show={show} onHide={onClose} placement="end">
        <Offcanvas.Header
          closeButton
          backButton="Close"
          icon="close"
          className="pb-0"
        >
          <Offcanvas.Title>Add Topics</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p className="help-text fs-6 fw-semibold">
            Please fill the form below and select topics.
          </p>

          <FloatingLabel controlId="topicsId" label="Topics" className="mb-4">
            <Form.Control type="text" placeholder="Topics" value={topics} onChange={(e)=>setTopics(e?.target?.value)} />
          </FloatingLabel>
          <DropdownCommon
            className="mb-4"
            name="subject"
            value={selectedSubject}
            setSelectedValue={setSelectedSubject}
            items={subjects}
            label="Subject"
          />
        </Offcanvas.Body>
        <Offcanvas.Footer>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Save
          </Button>
        </Offcanvas.Footer>
      </Offcanvas>
    </>
  );
}

export default AddOffcanvas;
